import React, { useEffect, useMemo, useState } from "react";
import "./StockCaptureModal.css";
import { cargarNombresOficialesStock } from "./stockCatalogoOficial";

const INSUMOS = [
  { key: "plasticos", label: "Plásticos PVC" },
  { key: "ribbon", label: "Ribbon" },
  { key: "laminador", label: "Laminador" },
  { key: "retransfer", label: "Retransfer" },
  { key: "rollos", label: "Rollo térmico terminal" },
];

function numberOrZeroPreserveZero(value) {
  if (value === undefined || value === null || value === "") {
    return 0;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

function normalizeText(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase()
    .trim();
}

function getRowId(row) {
  return row.oficinaId || row.id || row.oficina || "";
}

function isK30Office(row) {
  const oficinaId = normalizeText(row.oficinaId || row.id);
  const oficina = normalizeText(row.oficina || row.nombre);
  const municipio = normalizeText(row.municipio);

  const isOthonPBlanco =
    oficinaId.includes("OTHON") ||
    oficina.includes("OTHON") ||
    oficina.includes("P BLANCO") ||
    municipio.includes("OTHON") ||
    municipio.includes("P BLANCO");

  const isTransitoCancunBenitoJuarez =
    oficinaId.includes("BENITO_TRANSITO") ||
    oficinaId.includes("BENITO_JUAREZ_TRANSITO") ||
    oficinaId.includes("TRANSITO_CANCUN") ||
    oficina.includes("BENITO JUAREZ TRANSITO") ||
    oficina.includes("TRANSITO CANCUN") ||
    oficina.includes("CANCUN TRANSITO") ||
    (municipio.includes("BENITO JUAREZ") && oficina.includes("TRANSITO"));

  return isOthonPBlanco || isTransitoCancunBenitoJuarez;
}

function normalizeRows(rows) {
  if (!Array.isArray(rows)) {
    return [];
  }

  return rows.map(function(row) {
    const stock = row.stock || {};
    const isK30 = row.nuevaOficina
      ? row.impresora === "K30_SWITF_PRO"
      : isK30Office(row);

    return {
      ...row,
      oficinaId: row.oficinaId || row.id,
      id: row.id || row.oficinaId,
      impresora: row.nuevaOficina ? row.impresora : (isK30 ? "K30_SWITF_PRO" : "IDP_SMART_51L"),
      modelo: row.nuevaOficina ? row.impresora : (isK30 ? "K30_SWITF_PRO" : "IDP_SMART_51L"),
      promedioMensual: row.nuevaOficina ? (row.promedioMensual ?? "") : numberOrZeroPreserveZero(row.promedioMensual),
      stock: {
        plasticos: row.nuevaOficina ? (stock.plasticos ?? row.plasticos ?? "") : numberOrZeroPreserveZero(stock.plasticos ?? row.plasticos),
        ribbon: row.nuevaOficina ? (stock.ribbon ?? row.ribbon ?? "") : numberOrZeroPreserveZero(stock.ribbon ?? row.ribbon),
        laminador: row.nuevaOficina ? (stock.laminador ?? row.laminador ?? "") : numberOrZeroPreserveZero(stock.laminador ?? row.laminador),
        retransfer: isK30 ? (row.nuevaOficina ? (stock.retransfer ?? row.retransfer ?? "") : numberOrZeroPreserveZero(stock.retransfer ?? row.retransfer)) : 0,
        rollos: row.nuevaOficina ? (stock.rollos ?? row.rollos ?? "") : numberOrZeroPreserveZero(stock.rollos ?? row.rollos),
      },
    };
  });
}

const TOTAL_IMPRESORAS_POR_OFICINA = {
  BACALAR: 1,
  BJ_TRANSITO: 5,
  BJ_TAXISTAS: 4,
  COZUMEL: 2,
  FELIPE_CARRILLO_PUERTO: 2,
  ISLA_MUJERES_CONTINENTAL: 2,
  ISLA_MUJERES_INSULAR: 1,
  JOSE_MARIA_MORELOS: 1,
  LAZARO_CARDENAS: 1,
  OTHON_P_BLANCO: 5,
  PUERTO_MORELOS: 2,
  PLAYA_TRANSITO: 3,
  PLAYA_PALMERAS: 7,
  TULUM: 2,
  UNIDAD_MOVIL_1: 1,
  UNIDAD_MOVIL_2: 1,
};

function getTotalImpresorasModal(row) {
  const oficinaId = String(row?.oficinaId || row?.id || "").toUpperCase();
  if (row?.nuevaOficina) {
    const value = Number(row.totalImpresoras);
    return Number.isInteger(value) && value > 0 ? value : 0;
  }
  return TOTAL_IMPRESORAS_POR_OFICINA[oficinaId] || 1;
}

function numberModal(value) {
  if (value === undefined || value === null || value === "") return 0;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

function getModalStockValue(row, key) {
  return numberModal(row?.stock?.[key] ?? row?.[key]);
}

function normalizePrinterTextModal(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase()
    .trim();
}

function isK30Modal(row) {
  const raw = normalizePrinterTextModal(row?.impresora || row?.modelo || row?.printerLabel);
  const oficinaId = normalizePrinterTextModal(row?.oficinaId || row?.id);
  const oficina = normalizePrinterTextModal(row?.oficina || row?.nombre);
  const municipio = normalizePrinterTextModal(row?.municipio);

  return (
    raw.includes("K30") ||
    oficinaId.includes("BJ_TRANSITO") ||
    oficinaId.includes("BENITO_TRANSITO") ||
    oficinaId.includes("OTHON_P_BLANCO") ||
    oficina.includes("TRANSITO CANCUN") ||
    oficina.includes("BENITO JUAREZ TRANSITO") ||
    municipio.includes("OTHON")
  );
}

function getCoberturaImpresorasModal(row) {
  const impresorasConfiguradas = getTotalImpresorasModal(row);

  if (
    row?.nuevaOficina &&
    (!row.impresora || impresorasConfiguradas < 1)
  ) {
    return {
      totalImpresoras: 0,
      vueltasOperativas: 0,
      materialLimitante: "Sin configuracion",
      coberturaTarjetas: 0,
      coberturaRibbon: 0,
      coberturaLaminador: 0,
      coberturaRetransfer: null,
      coberturaRollos: 0,
      puedeImprimir: false,
      sinConfiguracion: true
    };
  }

  const totalImpresoras = Math.max(1, impresorasConfiguradas);

  const plasticos = getModalStockValue(row, "plasticos");
  const ribbon = getModalStockValue(row, "ribbon");
  const laminador = getModalStockValue(row, "laminador");
  const retransfer = getModalStockValue(row, "retransfer");
  const rollos = getModalStockValue(row, "rollos");

  const coberturaTarjetas = Math.floor(plasticos / totalImpresoras);
  const coberturaRibbon = Math.floor(ribbon / totalImpresoras);
  const coberturaLaminador = Math.floor(laminador / totalImpresoras);
  const coberturaRetransfer = isK30Modal(row)
    ? Math.floor(retransfer / totalImpresoras)
    : null;
  const coberturaRollos = Math.floor(rollos / totalImpresoras);

  const materialesImpresion = [
    { key: "Tarjetas", value: coberturaTarjetas },
    { key: "Ribbon", value: coberturaRibbon },
    { key: "Laminador", value: coberturaLaminador },
    ...(coberturaRetransfer === null ? [] : [{ key: "Retransfer", value: coberturaRetransfer }]),
  ];

  const vueltasOperativas = Math.max(
    0,
    Math.min(...materialesImpresion.map((item) => item.value))
  );

  const materialLimitante = materialesImpresion
    .slice()
    .sort((a, b) => a.value - b.value)[0];

  return {
    totalImpresoras,
    vueltasOperativas,
    materialLimitante: materialLimitante?.key || "Material",
    coberturaTarjetas,
    coberturaRibbon,
    coberturaLaminador,
    coberturaRetransfer,
    coberturaRollos,
    puedeImprimir: vueltasOperativas >= 1,
  };
}
export default function StockCaptureModal({
  ultimaCapturaInventario,
  open = false,
  rows = [],
  onClose,
  onUpdateStock,
  onUpdateAverage,
  onSave,
  savingStock = false,
}) {
  const [draftRows, setDraftRows] = useState([]);

  // IP_DEPOT_STOCK_CATALOGO_V1
  const [catalogoOficialStock, setCatalogoOficialStock] = useState({});

  useEffect(() => {
    if (!open) return;

    let activo = true;

    cargarNombresOficialesStock()
      .then(datos => {
        if (activo) setCatalogoOficialStock(datos);
      })
      .catch(error => {
        console.warn("[STOCK_CATALOGO] Manteniendo nombres originales", error);
        if (activo) setCatalogoOficialStock({});
      });

    return () => {
      activo = false;
    };
  }, [open]);

  useEffect(function() {
    if (open) {
      setDraftRows(normalizeRows(rows));
    }
  }, [open]);

  const oficinasCount = useMemo(function() {
    return draftRows.length;
  }, [draftRows]);

  if (!open) {
    return null;
  }

  function handleStockChange(oficinaId, field, value) {
    const parsed = numberOrZeroPreserveZero(value);

    setDraftRows(function(current) {
      return current.map(function(row) {
        const rowId = getRowId(row);
        const isK30 = isK30Office(row);

        if (rowId !== oficinaId) {
          return row;
        }

        if (field === "retransfer" && !isK30) {
          return {
            ...row,
            stock: {
              ...(row.stock || {}),
              retransfer: 0,
            },
          };
        }

        return {
          ...row,
          stock: {
            ...(row.stock || {}),
            [field]: parsed,
            },
            ...(row.nuevaOficina ? {
              camposCapturados: [
                ...new Set([...(row.camposCapturados || []), field])
              ]
            } : {})
          };
      });
    });

    if (field === "retransfer") {
      const target = draftRows.find(function(row) {
        return getRowId(row) === oficinaId;
      });

      if (target && !isK30Office(target)) {
        if (typeof onUpdateStock === "function") {
          onUpdateStock(oficinaId, field, 0);
        }
        return;
      }
    }

    if (typeof onUpdateStock === "function") {
      onUpdateStock(oficinaId, field, parsed);
    }
  }

  function handleAverageChange(oficinaId, value) {
    const parsed = numberOrZeroPreserveZero(value);

    setDraftRows(function(current) {
      return current.map(function(row) {
        const rowId = getRowId(row);

        if (rowId !== oficinaId) {
          return row;
        }

        return {
          ...row,
          promedioMensual: parsed,
          ...(row.nuevaOficina ? { promedioCapturado: true } : {})
        };
      });
    });

    if (typeof onUpdateAverage === "function") {
      onUpdateAverage(oficinaId, parsed);
    }
  }

  async function handleSave() {
        const nuevas = draftRows.filter(row => row.nuevaOficina);

    const completas = [];

    for (const row of nuevas) {
      const modificada =
        Boolean(row.impresora) ||
        row.totalImpresoras !== null ||
        Boolean(row.promedioCapturado) ||
        (row.camposCapturados || []).length > 0;

      if (!modificada) continue;

      const campos = ["plasticos", "ribbon", "laminador", "rollos"];

      if (row.impresora === "K30_SWITF_PRO") {
        campos.push("retransfer");
      }

      const cantidad = Number(row.totalImpresoras);

      const valida =
        ["IDP_SMART_51L", "K30_SWITF_PRO"].includes(row.impresora) &&
        Number.isInteger(cantidad) &&
        cantidad > 0 &&
        row.promedioCapturado === true &&
        campos.every(campo =>
          (row.camposCapturados || []).includes(campo)
        );

      if (!valida) {
        window.alert(
          "Completa modelo, impresoras, promedio y existencias de " +
          (row.oficina || row.oficinaId)
        );
        return;
      }

      completas.push(row);
    }

    const rowsToSave = normalizeRows([
      ...draftRows.filter(row => !row.nuevaOficina),
      ...completas
    ]);

    console.log("STOCK_MODAL_SAVE_CLICK", rowsToSave);

    let saved = true;

    if (typeof onSave === "function") {
      saved = await onSave(rowsToSave);
    }

    if (saved === false) {
      window.alert("No se pudo guardar el stock. Revisa el error e intenta nuevamente.");
      return;
    }

    window.alert("Stock guardado exitosamente. Requisición recalculada.");

    if (typeof onClose === "function") {
      onClose();
    }
  }

  return (
    <div className="stock-capture-overlay">
      <section className="stock-capture-modal">
        <header className="stock-capture-header">
          <div>
            <h2>Stock por oficina</h2>
            
          </div>

          <button
            type="button"
            className="stock-capture-close"
            onClick={onClose}
            disabled={savingStock}
            aria-label="Cerrar"
          >
            ×
          </button>
        </header>

        <div className="stock-capture-summary">
          <strong>{oficinasCount}</strong>
          <span>oficinas disponibles para captura</span>
        </div>

        <div className="stock-capture-last-updated">
          <div className="stock-capture-last-updated-title">
            <span aria-hidden="true">◷</span>
            <span>Última actualización de inventario</span>
          </div>
          <strong className="stock-capture-last-updated-value">
            {(() => {
              if (!ultimaCapturaInventario) {
                return "Sin actualización registrada";
              }
              const fecha = new Date(ultimaCapturaInventario);
              if (Number.isNaN(fecha.getTime())) {
                return "Sin actualización registrada";
              }
              return new Intl.DateTimeFormat("es-MX", {
                timeZone: "America/Cancun",
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
              }).format(fecha) + " h";
            })()}
          </strong>
          <span className="stock-capture-last-updated-note">
            Fecha de la última captura registrada
          </span>
        </div>

        <div className="stock-capture-table-wrap">
          <table className="stock-capture-table">
            <thead>
              <tr>
                <th>Oficina</th>
                  <th>Total impresoras</th>
                  <th>Capacidad operativa</th>
                <th>Promedio mensual</th>
                {INSUMOS.map(function(insumo) {
                  return <th key={insumo.key}>{insumo.label}</th>;
                })}
              </tr>
            </thead>

            <tbody>
              {draftRows.map(function(row) {
                const oficinaId = getRowId(row);
                const stock = row.stock || {};
                const isK30 = isK30Office(row);
                const nombreOficial = catalogoOficialStock[oficinaId] || null;

                return (
                  <tr key={oficinaId}>
                    <td>
                      <strong>{nombreOficial?.nombre || row.oficina || row.nombre || oficinaId}</strong>
{row.nuevaOficina && (
  <div style={{ marginTop: 6 }}>
    <select
      value={row.impresora || ""}
      onChange={event => {
        const modelo = event.target.value;
        setDraftRows(current => current.map(item =>
          getRowId(item) === oficinaId
            ? { ...item, impresora: modelo, modelo }
            : item
        ));
      }}
    >
      <option value="">Seleccionar impresora</option>
      <option value="IDP_SMART_51L">IDP SMART 51L</option>
      <option value="K30_SWITF_PRO">K30 SWITF PRO</option>
    </select>
    <small>Primera captura pendiente</small>
  </div>
)}
                      <small>
                        {nombreOficial?.municipio || row.municipio || ""} · {isK30 ? "K30 SWITF PRO" : "SMART 51L"}
                      </small>
                    </td>
                  <td className="stock-printers-count-cell">
                    {row.nuevaOficina ? (
  <input
    type="number"
    min="1"
    step="1"
    placeholder="Impresoras"
    value={row.totalImpresoras ?? ""}
    onChange={event => {
      const value = event.target.value;
      setDraftRows(current => current.map(item =>
        getRowId(item) === oficinaId
          ? { ...item, totalImpresoras: value }
          : item
      ));
    }}
  />
) : (
  <span>{getTotalImpresorasModal(row)}</span>
)}
                  </td>
                                                      <td className="stock-printer-coverage-cell">
                    {(() => {
                      const cobertura = getCoberturaImpresorasModal(row);

                      return (
                        <div className={cobertura.puedeImprimir ? "coverage-mini coverage-mini-ok" : "coverage-mini coverage-mini-risk"}>
                          <div className="coverage-mini-top">
                            <strong>{cobertura.vueltasOperativas}</strong>
                            <span>{cobertura.vueltasOperativas === 1 ? "vuelta completa" : "vueltas completas"}</span>
                          </div>

                          <div className="coverage-mini-meta">
                            <b>
  {cobertura.sinConfiguracion
    ? "Impresoras sin configurar"
    : `${cobertura.totalImpresoras} impresora(s)`}
</b>
                            <em>
  {cobertura.sinConfiguracion
    ? "Pendiente de configuracion"
    : cobertura.puedeImprimir
      ? "Operable"
      : `Limitante: ${cobertura.materialLimitante}`}
</em>
                          </div>

                          <div className="coverage-mini-grid">
                            <span>T {cobertura.coberturaTarjetas}</span>
                            <span>R {cobertura.coberturaRibbon}</span>
                            <span>L {cobertura.coberturaLaminador}</span>
                            {cobertura.coberturaRetransfer !== null ? (
                              <span>RT {cobertura.coberturaRetransfer}</span>
                            ) : null}
                            <span>Rollos {cobertura.coberturaRollos}</span>
                          </div>
                        </div>
                      );
                    })()}
                  </td>

                    <td>
                      <input
                        type="number"
                        min="0"
                        value={numberOrZeroPreserveZero(row.promedioMensual)}
                        onChange={function(event) {
                          handleAverageChange(oficinaId, event.target.value);
                        }}
                      />
                    </td>

                    {INSUMOS.map(function(insumo) {
                      const bloquearRetransfer = insumo.key === "retransfer" && !isK30;

                      return (
                        <td key={insumo.key}>
                          <input
                            type="number"
                            min="0"
                            disabled={bloquearRetransfer}
                            className={bloquearRetransfer ? "input-no-aplica" : ""}
                            title={bloquearRetransfer ? "Retransfer no aplica para SMART 51L" : ""}
                            value={bloquearRetransfer ? 0 : numberOrZeroPreserveZero(stock[insumo.key])}
                            onChange={function(event) {
                              handleStockChange(oficinaId, insumo.key, event.target.value);
                            }}
                          />
                          {bloquearRetransfer ? (
                            <small className="no-aplica-label">No aplica</small>
                          ) : null}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <footer className="stock-capture-footer">
          <button
            type="button"
            className="stock-capture-secondary"
            onClick={onClose}
            disabled={savingStock}
          >
            Cancelar
          </button>

          <button
            type="button"
            className="stock-capture-primary"
            onClick={handleSave}
            disabled={savingStock}
          >
            {savingStock ? "Guardando..." : "Guardar y recalcular"}
          </button>
        </footer>
      </section>
    </div>
  );
}








